/**
 * File: locationDisplay.js.
 *
 * Import and initialize functions for Location Display
 */

 import fetchLocations from "../helpers/fetchLocations";
 import mapLocations from "../helpers/mapLocation";
 import { debounce } from "../helpers/debounce";
 
  export default {
     container: document.querySelector('.udp-locations-listing'),
     init() {
         if (this.container) {
             this.render();
         }
     },
     async render() {
         const form = document.querySelector('[data-js-form=filter]');
         const input = document.querySelector('#location-search');
         let previousController = '';
        
         input.addEventListener('keydown', debounce(async(e) => {
             e.preventDefault();
             if(e.keyCode === 13 || e.which === 13) return;
             // aborts previous request
             if(previousController) {
                 previousController.abort();
             }
             const value = input.value !== '' ? input.value : 'null';
 
             // create new instance of abort controller
             const controller = new AbortController();
             const signal = controller.signal;
             previousController = controller;
 
             // fetch locations
             document.body.style.cursor = 'wait';
             const fetchedLocations = await fetchLocations(value, document.body.className.match(/page\-id\-(\d+)/)[1], signal);
             document.body.style.cursor = '';
             mapLocations(fetchedLocations, this.container, input);
         }, 300));
 
         // if user press enter
         form && ( form.onsubmit = async(e) => {
             e.preventDefault();
             const value = form.elements['location-search'].value !== '' ? form.elements['location-search'].value : 'null';
             document.body.style.cursor = 'wait';
             const fetchedLocations = await fetchLocations(value, document.body.className.match(/page\-id\-(\d+)/)[1]);
             document.body.style.cursor = '';
             mapLocations(fetchedLocations, this.container, input);
         }) 
     },
     finalize() {
     // JavaScript to be fired on all pages, after page specific JS is fired
     },
 };
   